import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-delete',
	path: '/secure/admin/DeleteCustomField!default.jspa',
};
